import { useEffect, useState } from "react";

const WORDS = ["Bonjour", "Welcome", "Willkommen", "Bienvenido", "Benvenuto", "Bem-vindo"];

export default function RotatingGreeting({ name, className = "text-lg sm:text-xl font-semibold" }) {
  const [i, setI] = useState(0);
  const [show, setShow] = useState(true);
  useEffect(() => {
    const t = setInterval(() => { setShow(false); setTimeout(() => { setI((x) => (x + 1) % WORDS.length); setShow(true); }, 500); }, 10000);
    return () => clearInterval(t);
  }, []);
  return (
    <p className={`${className} transition-opacity duration-500 ${show ? "opacity-100" : "opacity-0"}`} data-testid="rotating-greeting">
      {WORDS[i]} <span className="text-[#60A5FA]">{name}</span>
    </p>
  );
}
